import React from 'react';
import { Route } from 'react-router-dom';
import SoftwarePayment from '@/pages/admin/SoftwarePayment';
import MySubscription from '@/pages/admin/MySubscription';
import ActivityLog from '@/pages/admin/ActivityLog';
import AssignRoles from '@/pages/roles/AssignRoles';
import StaffByRole from '@/pages/roles/StaffByRole';
import RolePermissions from '@/pages/roles/RolePermissions';
import SubscriptionUpgrade from '@/pages/subscription/SubscriptionUpgrade';
import NoticeManagement from '@/pages/notices/NoticeManagement';
import DeleteLogs from '@/pages/audit/DeleteLogs';

export const adminRoutes = (
  <React.Fragment>
    <Route path="admin/software-payment" element={<SoftwarePayment />} />
    <Route path="admin/my-subscription" element={<MySubscription />} />
    <Route path="admin/subscription-upgrade" element={<SubscriptionUpgrade />} />
    <Route path="admin/activity-log" element={<ActivityLog />} />
    <Route path="admin/delete-logs" element={<DeleteLogs />} />
    <Route path="roles/assign" element={<AssignRoles />} />
    <Route path="roles/staff-by-role" element={<StaffByRole />} />
    <Route path="roles/permissions" element={<RolePermissions />} />
    <Route path="notices" element={<NoticeManagement />} />
  </React.Fragment>
);
